import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import { Suspense } from "react";
import AppRouter from "./router";
import { BrowserRouter } from "react-router-dom";
import Spinner from "./components/Spinner/Spinner";
import GeneralProvider from "./pages/General/Context";

const App = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<Spinner />}>
        <GeneralProvider>
          <AppRouter />
        </GeneralProvider>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
